export class NavItem {
    id: string
    name: string
    url: string

    constructor(id: string, name: string, url: string) {
        this.id = id
        this.name = name
        this.url = url
    }
}
